export default "__VITE_ASSET__CTAKeaQG__"